import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  optionDescription: {
    paddingBottom: theme.spacing(2),
  },

  gameList: {
    display: 'flex',
  },

  matchModeContainer: {
    display: 'flex',
    justifyContent: 'end',
  },

  modeOption: {
    cursor: 'pointer',
    padding: theme.spacing(0, 1),
  },

  author: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  modeHeader: {
    color: theme.palette.primary.light,
  },

  listContainer: {
    maxHeight: theme.spacing(40),
    overflowY: 'auto',
  },

  player: {
    maxWidth: theme.spacing(42),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
  },

  active: {
    textDecoration: 'underline',
  },
}));
